/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: "Corridor" | "Kitchen" | "Office" | "Room" | "Toilet" }} Room_TypeInputs */



/**
* | type | output |
* | --- | --- |
* | "Corridor" | "Corridor" |
* | "Kitchen" | "Kitchen" |
* | "Office" | "Office" |
* | "Room" | "Room" |
* | "Toilet" | "Toilet" |
*
* @param {Room_TypeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const room_type = /** @type {((inputs: Room_TypeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_TypeInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.type === "Corridor") return /** @type {LocalizedString} */ (`Corridor`);
		if (i?.type === "Kitchen") return /** @type {LocalizedString} */ (`Kitchen`);
		if (i?.type === "Office") return /** @type {LocalizedString} */ (`Office`);
		if (i?.type === "Room") return /** @type {LocalizedString} */ (`Room`);
		if (i?.type === "Toilet") return /** @type {LocalizedString} */ (`Toilet`);
		return /** @type {LocalizedString} */ ("room_type");
	}
	{
		if (i?.type === "Corridor") return /** @type {LocalizedString} */ (`Couloir`);
		if (i?.type === "Kitchen") return /** @type {LocalizedString} */ (`Cuisine`);
		if (i?.type === "Office") return /** @type {LocalizedString} */ (`Bureau`);
		if (i?.type === "Room") return /** @type {LocalizedString} */ (`Chambre`);
		if (i?.type === "Toilet") return /** @type {LocalizedString} */ (`Toilettes`);
		return /** @type {LocalizedString} */ ("room_type");
	}
});